import { getComponentFromName } from '@folklore/utils';
import classNames from 'classnames';
import { Suspense } from 'react';

import * as InteractiveComponents from '../../interactives';

import styles from '../../styles/documents/interactive-document.module.css';

export interface InteractiveDocumentProps extends Partial<InterfactiveDocument> {
    className?: string | null;
}

function InteractiveDocument({
    component = null,
    className = null,
    ...props
}: InteractiveDocumentProps) {
    const InteractiveComponent = getComponentFromName(InteractiveComponents, component);
    return (
        <div className={classNames([styles.container, className])}>
            <Suspense fallback={<div className={styles.loading} />}>
                {InteractiveComponent !== null ? <InteractiveComponent {...props} /> : null}
            </Suspense>
        </div>
    );
}

export default InteractiveDocument;
